import { WHEEL_LABELS, type WheelPlacement } from '@camper-diary/shared';

type Props = {
  placement: WheelPlacement;
  /** i gradini del cuneo assegnato a questa ruota, per disegnare la rampa */
  steps: number[];
};

const RAMP_W = 120;
const RAMP_H = 54;
const PAD = 3;

/**
 * Una ruota: quale, il numero del gradino, l'altezza in centimetri e il disegnino
 * del cuneo con il gradino da usare acceso. Il numero da solo si confonde con
 * l'altra ruota; il disegno dice subito "questo, il terzo".
 */
export function WedgeAdvice({ placement, steps }: Props) {
  const onGround = placement.step === 0;
  // I gradini arrivano ordinati dal server: l'ultimo è il più alto, e serve a
  // dare la scala al disegno. Senza gradini non si divide per zero.
  const tallest = steps[steps.length - 1] ?? 1;

  return (
    <div className={`wheel${onGround ? ' ground' : ' acting'}`}>
      <span className="tag">{WHEEL_LABELS[placement.wheel]}</span>
      <span className="step">{onGround ? 'a terra' : placement.step}</span>
      <span className="cm">
        {onGround
          ? 'nessun cuneo'
          : `${placement.height.toFixed(1)} cm — cuneo ${placement.wedge}`}
      </span>
      <svg className="ramp" viewBox={`0 0 ${RAMP_W} ${RAMP_H}`} aria-hidden="true">
        {steps.map((height, i) => {
          const treadW = (RAMP_W - PAD * 2) / steps.length;
          const h = Math.max(6, ((RAMP_H - PAD * 2) * height) / tallest);
          return (
            <rect
              key={height}
              className={i + 1 === placement.step ? 'tread on' : 'tread'}
              x={(PAD + i * treadW).toFixed(2)}
              y={(RAMP_H - PAD - h).toFixed(2)}
              width={(treadW - 1.5).toFixed(2)}
              height={h.toFixed(2)}
              rx="1.5"
            />
          );
        })}
      </svg>
    </div>
  );
}
